import React, { useEffect, useState, useRef, createContext } from 'react';
import {
    Fashionlotties,
    Footwearlotties,
    shuffleArray,
    loadingEcomMessages,
    loadingFootwearMessages,
    shuffleArrayMessage,
    getRandomTime,
} from '../LoaderCard/lottieUtils';
import { loadStateSession } from '../../../../FlyfishComponents/flyfishutils/utils';
import lottieLight from 'lottie-web/build/player/lottie_light.min.js';
import styled from 'styled-components';
import useScreenType from '../../../../Hooks/DeviceType';
export const LoaderWrapper = styled.div`
	background-color: #fff;
	aspect-ratio: ${(props) =>
        loadStateSession('productCardAspectRatio')
            ? `${loadStateSession('productCardAspectRatio')}`
            : 'unset'};
	border-radius: 8px;
	border: 1px solid rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	flex-grow: 0;
	justify-content: center;
	align-items: center;
	box-shadow: none !important;
	max-height: 400px;
    width:23%;
	.ff-lottie-container {
		width: 80%;
		aspect-ratio: 1;
		border-radius: 100%;
		background-color: unset !important;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background-color 0.5s ease;
		position: relative;
		z-index: 0;
		@media screen and (max-width: 600px) {
			width: calc(50% - 6px);
		}
	}
	.ff-lottie {
		width: 70%;
		position: relative;
	}
	.ff-fashion-tip {
		margin: 0px 16px;
		line-height: 1.4;
		text-align: center;
		min-height: 56px;
		color: var(--ffNeutral500);
		font-weight: 100;
	}
`;
export const LoaderWrapperParent = styled.div`
	display: flex;
	padding-top: 24px;
	width: calc(100%);
	gap: 12px;
	height: 100vh;
	background-color: #faf8fc;
	flex-direction: column;
	align-items: center;
    margin-top: 10px;
	@media screen and (max-width: 600px) {
		grid-template-columns: 1fr 1fr;
	}
	.ff-fashion-tip {
		color: var(--neutral-color-ff-neutral600);
		font-size: 20px;
		line-height: 28px;
		padding: 12px 24px;
		letter-spacing: 0.6px;
	}
	&.mobile,
	&.tablet {
		overflow: auto;
		height: calc(100vh - 100px);
		& > div:not(.ff-fashion-tip) {
			display: grid !important;
			grid-template-columns: 1fr 1fr;
			gap: 12px !important;
			padding: 0 12px;
			& .ff-fashion-tip {
				grid-column: span 2;
				text-align: center;
				padding: 24px;
			}
			& > .ff-loader-card {
                width: auto;
				aspect-ratio: ${(props) =>
        loadStateSession('productCardAspectRatio')
            ? `${loadStateSession('productCardAspectRatio')}`
            : 'unset'};
			}
		}
	}
`;
type Props = {
    disableMsg;
    ecomSearchVertical;
}
const ProductLoader = ({ disableMsg,ecomSearchVertical }: Props) => {
    const [imageOne, setimageOne] = useState('');
    const [imageTwo, setimageTwo] = useState('');
    const [imageThree, setimageThree] = useState('');
    const [imageFour, setimageFour] = useState('');

    const [ImageOneSVG, setimageOneSVG] = useState<any>('');
    const [ImageTwoSVG, setimageTwoSVG] = useState<any>('');
    const [ImageThreeSVG, setimageThreeSVG] = useState<any>('');
    const [ImageFourSVG, setimageFourSVG] = useState<any>('');

    const imageOneRef = useRef(null);
    const imageTwoRef = useRef(null);
    const imageThreeRef = useRef(null);
    const imageFourRef = useRef(null);

    const imageOneSVGRef = useRef(null);
    const imageTwoSVGRef = useRef(null);
    const imageThreeSVGRef = useRef(null);
    const imageFourSVGRef = useRef(null);

    const [imageOneColor, setimageOneColor] = useState('');
    const [imageTwoColor, setimageTwoColor] = useState('');
    const [imageThreeColor, setimageThreeColor] = useState('');
    const [imageFourColor, setimageFourColor] = useState('');
    const [seqNumber, setseqNumber] = useState(0);
    const [showSvg, setShowSvg] = useState(false);
    const switchAfterDuration = 7000;
    const playbackSpeed = 4000 / switchAfterDuration;
    const seed = Math.floor(Math.random() * 1000000);
    const switchSvg = switchAfterDuration / 2;
    const [randomMessage, setRandomMessage] = useState('');
    const loadingMessageDurationMin = 6000;
    const loadingMessageDurationMax = 8000;
    const directTimeout = useRef(null);
    let runNumber = 0;
    const intervalIds = useRef([]);
    const lottieInterval = useRef(null)
    const lottieTimeout = useRef(null);
    const deviceType = useScreenType();
    const loadingDirectMessages=ecomSearchVertical === 'footwear'?loadingFootwearMessages:loadingEcomMessages
    const Directlotties=ecomSearchVertical === 'footwear'?Footwearlotties:Fashionlotties
    useEffect(() => {
        loopThroughLottieSequence(1, seed);
        loopThroughLottieSequence(2, seed);
        loopThroughLottieSequence(3, seed);
        loopThroughLottieSequence(4, seed);
        startLoadingDirectMessages();
        return () => {
            // Cleanup code here
            clearInterval(lottieInterval.current);
            clearTimeout(lottieTimeout.current);
            clearTimeout(directTimeout.current);
            intervalIds.current.forEach((id) => clearInterval(id));
            console.log(intervalIds)
        };
    }, []);
    const loopThroughLottieSequence = (lottieSequenceNumber, seed) => {


        let i = 0;
        let lottieArray = ['lottie1', 'lottie2', 'lottie3', 'lottie4'];
        let shuffledArray = shuffleArray([...lottieArray], seed);
        let colorPattern = 3;
        function loadNextLottie() {
            if (i >= shuffledArray.length) {
                shuffledArray = shuffleArray([...lottieArray], seed);
                i = 0;
            }
            const lottieData =
                Directlotties[`lottieSequence${lottieSequenceNumber}`][shuffledArray[i]]
                    .url;
            let lottieColor =
                Directlotties[`lottieSequence${lottieSequenceNumber}`].colorSequence[
                `colorPattern${colorPattern}`
                ][
                runNumber %
                Directlotties[`lottieSequence${lottieSequenceNumber}`]
                    .colorSequence[`colorPattern${colorPattern}`].length
                ];
            const lottieDataSVG =
                Directlotties[`lottieSequence${lottieSequenceNumber}`][shuffledArray[i]]
                    .svg;
            setseqNumber(lottieSequenceNumber);
            if (lottieSequenceNumber === 1) {
                setimageOneSVG(() => lottieDataSVG)
                setimageOne(lottieData);
                setimageOneColor(lottieColor);
            }
            if (lottieSequenceNumber === 2) {
                setimageTwoSVG(() => lottieDataSVG)
                setimageTwo(lottieData);
                setimageTwoColor(lottieColor);
            }
            if (lottieSequenceNumber === 3) {
                setimageThreeSVG(() => lottieDataSVG)
                setimageThree(lottieData);
                setimageThreeColor(lottieColor);
            }
            if (lottieSequenceNumber === 4) {
                setimageFourSVG(() => lottieDataSVG)
                setimageFour(lottieData);
                setimageFourColor(lottieColor);
            }
            if (
                lottieSequenceNumber ===
                Object.keys(Directlotties).filter((key) =>
                    key.startsWith('lottieSequence')
                ).length
            ) {
                runNumber = runNumber + 1;
            }

            i++;
        }

        lottieTimeout.current = setTimeout(() => {
            console.log('TIMEOUT');
            loadNextLottie();
            setTimeout(() => {
                console.log('SVG Show')
                setShowSvg(true)
                setTimeout(() => {
                    setShowSvg(false);
                    console.log('SVG not show')
                    console.log(intervalIds)
                }, 1000);
            }, switchSvg);

        }, 300);

        lottieInterval.current = setInterval(() => {
            console.log('INTERVAL')
            loadNextLottie();
            setTimeout(() => {
                setShowSvg(true)
                setTimeout(() => {
                    setShowSvg(false)
                }, 1000);
            }, switchSvg);

        }, switchAfterDuration);
        intervalIds.current.push(lottieInterval.current);
    };
    const startLoadingDirectMessages = () => {
        const displayElement = document.getElementById('loadingMessage'); // Element to display messages
        let shuffledSet = shuffleArrayMessage([...loadingDirectMessages]); // Shuffle the flat array initially
        let message = '';

        function displayRandomMessage() {
            if (shuffledSet.length === 0) {
                shuffledSet = shuffleArrayMessage([...loadingDirectMessages]); // Reshuffle when all messages are used
            }
            message = shuffledSet.shift();

            setRandomMessage(message);
        }

        function loopMessages() {
            displayRandomMessage();
            directTimeout.current = setTimeout(
                loopMessages,
                getRandomTime(loadingMessageDurationMin, loadingMessageDurationMax)
            ); // Loop with random time interval
        }

        loopMessages(); // Start the message loop
    };

    useEffect(() => {
        let imageOneInstance;
        let imageTwoInstance;
        let imageThreeInstance;
        let imageFourInstance;

        if (imageOneRef.current && seqNumber === 1) {

            let removeElem = imageOneRef.current.querySelector('svg')
            removeElem && removeElem.remove();
            imageOneInstance = lottieLight.loadAnimation({
                container: imageOneRef.current,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: imageOne,
            });
            imageOneInstance.setSpeed(playbackSpeed)

            const svgElement = imageOneRef.current.querySelector('svg');
            const paths = svgElement.querySelectorAll('path');

            // Assign the single color to all paths
            paths.forEach((path) => {
                path.setAttribute('stroke', imageOneColor); // Apply the color to each path
            });

            // Optional: Change stroke width
            paths.forEach((path) => {
                path.setAttribute('stroke-width', '1'); // Set stroke width
            });
        }

        if (imageTwoRef.current && seqNumber === 2) {

            let removeElem = imageTwoRef.current.querySelector('svg')
            removeElem && removeElem.remove();
            imageTwoInstance = lottieLight.loadAnimation({
                container: imageTwoRef.current,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: imageTwo,
            });
            imageTwoInstance.setSpeed(playbackSpeed)

            const svgElement = imageTwoRef.current.querySelector('svg');
            const paths = svgElement.querySelectorAll('path');

            // Assign the single color to all paths
            paths.forEach((path) => {
                path.setAttribute('stroke', imageTwoColor); // Apply the color to each path
            });

            // Optional: Change stroke width
            paths.forEach((path) => {
                path.setAttribute('stroke-width', '1'); // Set stroke width
            });
        }
        if (imageThreeRef.current && seqNumber === 3) {

            let removeElem = imageThreeRef.current.querySelector('svg')
            removeElem && removeElem.remove();
            imageThreeInstance = lottieLight.loadAnimation({
                container: imageThreeRef.current,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: imageThree,
            });
            imageThreeInstance.setSpeed(playbackSpeed)
            const svgElement = imageThreeRef.current.querySelector('svg');
            const paths = svgElement.querySelectorAll('path');

            // Assign the single color to all paths
            paths.forEach((path) => {
                path.setAttribute('stroke', imageThreeColor); // Apply the color to each path
            });

            // Optional: Change stroke width
            paths.forEach((path) => {
                path.setAttribute('stroke-width', '1'); // Set stroke width
            });
        }

        if (imageFourRef.current && seqNumber === 4) {

            let removeElem = imageFourRef.current.querySelector('svg')
            removeElem && removeElem.remove();
            imageFourInstance = lottieLight.loadAnimation({
                container: imageFourRef.current,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: imageFour,
            });
            imageFourInstance.setSpeed(playbackSpeed)

            const svgElement = imageFourRef.current.querySelector('svg');
            const paths = svgElement.querySelectorAll('path');

            // Assign the single color to all paths
            paths.forEach((path) => {
                path.setAttribute('stroke', imageFourColor); // Apply the color to each path
            });

            // Optional: Change stroke width
            paths.forEach((path) => {
                path.setAttribute('stroke-width', '1'); // Set stroke width
            });
        }
    }, [imageOneColor, imageTwoColor, imageThreeColor, imageFourColor]);


    return (
        <LoaderWrapperParent
            className={`ff-loader-wrapper-parent ${deviceType}`}
        >
            {deviceType === 'desktop' && !disableMsg ? (
                <div className='ff-fashion-tip'>{randomMessage}</div>
            ) : null}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '8px',
                }}
            >
                {Array.from({ length: 4 }, (_, index) => (
                    <>
                        {deviceType !== 'desktop' && index === 2 && !disableMsg ? (
                            <div className='ff-fashion-tip'>{randomMessage}</div>
                        ) : null}
                        <LoaderWrapper className='ff-loader-card' >
                            <div className='ff-lottie-container'>
                                <div className='ff-lottie'>
                                    {index === 0 && ImageOneSVG &&
                                        <div>
                                            <ImageOneSVG
                                                color={imageOneColor}
                                                preserveAspectRatio="xMidYMid meet"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    position: 'absolute',
                                                    top: '-2px',
                                                    opacity: showSvg ? '1' : '0'
                                                }}

                                            />
                                        </div>
                                    }
                                    {index === 1 && ImageTwoSVG &&
                                        <div>
                                            <ImageTwoSVG
                                                color={imageTwoColor}
                                                preserveAspectRatio="xMidYMid meet"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    position: 'absolute',
                                                    top: '-2px',
                                                    opacity: showSvg ? '1' : '0'
                                                }}

                                            />
                                        </div>
                                    }
                                    {index === 2 && ImageThreeSVG &&
                                        <div>
                                            <ImageThreeSVG
                                                color={imageThreeColor}
                                                preserveAspectRatio="xMidYMid meet"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    position: 'absolute',
                                                    top: '-2px',
                                                    opacity: showSvg ? '1' : '0'
                                                }}

                                            />
                                        </div>
                                    }

                                    {index === 3 && ImageFourSVG &&
                                        <div>
                                            <ImageFourSVG
                                                color={imageFourColor}
                                                preserveAspectRatio="xMidYMid meet"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    position: 'absolute',
                                                    top: '-2px',
                                                    opacity: showSvg ? '1' : '0'
                                                }}

                                            />
                                        </div>
                                    }
                                    <div
                                        style={{ opacity: !showSvg ? '1' : '0' }}
                                        ref={index == 0 ? imageOneRef : index == 1 ? imageTwoRef : index == 2 ? imageThreeRef : imageFourRef}></div>
                                </div>
                            </div>
                        </LoaderWrapper>
                    </>
                ))}
            </div>
        </LoaderWrapperParent>
    )

}
export default ProductLoader
